import { ApiConstants } from '@epi-constants/actions';
import { IBenefitGroupSettings } from '@epi-models/pages/Beneficiaries';
import { fetchActiveBenefits as fetchActiveBenefitsRequest } from '@epi-repositories/BenefitGroupSettingsRepository';
import {
  createAction,
  createAsyncThunk,
  createSlice,
  PayloadAction
} from '@reduxjs/toolkit';

const logoutSuccess = createAction(`${ApiConstants.LOGOUT_ACTION}_SUCCESS`);

export type BenefitGroupSettingsState = {
  benefitGroupSettings: IBenefitGroupSettings[];
  activeBenefits: string[];
  isActiveBenefitsLoaded: boolean;
  isOrderInProgress: boolean;
  goToPageLink: string;
};

const initialState: BenefitGroupSettingsState = {
  benefitGroupSettings: [],
  activeBenefits: [],
  isActiveBenefitsLoaded: false,
  isOrderInProgress: false,
  goToPageLink: ''
};

export const fetchActiveBenefits = createAsyncThunk(
  'benefitGroupSettings/fetchActiveBenefits',
  async () => {
    const response = await fetchActiveBenefitsRequest();

    return response.map((type: string) => type.toLowerCase());
  }
);

const benefitGroupSettingsSlice = createSlice({
  name: 'benefitGroupSettings',
  initialState,
  reducers: {
    startOrderProcess: state => {
      state.isOrderInProgress = true;
    },
    stopOrderProcess: state => {
      state.isOrderInProgress = false;
    },
    setGoToPageLink: (state, { payload }: PayloadAction<string>) => {
      state.goToPageLink = payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(logoutSuccess, () => initialState)
      .addCase(fetchActiveBenefits.fulfilled, (state, { payload }) => {
        state.activeBenefits = payload;
        state.isActiveBenefitsLoaded = true;
      });
  }
});

export const { reducer, actions: benefitGroupSettingsActions } =
  benefitGroupSettingsSlice;
